@if (value) {
  <div class="heading">
    <app-template-html [value]="value" [control]="control" />
  </div>
}
